import { render, staticRenderFns } from "./AssignRatingButton.vue?vue&type=template&id=2a0a79b3&"
import script from "./AssignRatingButton.vue?vue&type=script&lang=js&"
export * from "./AssignRatingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports